module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_sakura-ecb88cdb5d9222df42af2561646274ce.jpg";